import React from 'react';
import PropTypes from 'prop-types';
import { mergeClasses } from '@fluentui/react-components';
import { AssetsEntryCardContainer } from './assets-entry-cards-container';
import { useVideoPageTopBannerContainerStyle } from '../../styles';

const TopVideoPageBannerComponent = ({
  i18n,
  aid,
  cid,
  oDataConfig,
  navigation,
  logger,
  permissions,
}) => {
  const classes = useVideoPageTopBannerContainerStyle();
  return (
    <div className={mergeClasses('top-banner', classes.topBanner)}>
      <div className={classes.texts}>
        <div className={classes.pageName} role="heading" aria-level="1">
          {i18n.getString(_TL_('Videos'))}
        </div>
        <div className={classes.descriptions}>
          {i18n.getString(_TL_('Add new videos or search for existing ones'))}
        </div>
      </div>
      <div className={classes.entryCard}>
        <AssetsEntryCardContainer
          i18n={i18n}
          aid={aid}
          cid={cid}
          oDataConfig={oDataConfig}
          navigation={navigation}
          logger={logger}
          permissions={permissions}
        />
      </div>
    </div>
  );
};

TopVideoPageBannerComponent.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  aid: PropTypes.number.isRequired,
  cid: PropTypes.number.isRequired,
  oDataConfig: PropTypes.shape({}).isRequired,
  navigation: PropTypes.shape({}).isRequired,
  logger: PropTypes.shape({
    logTrace: PropTypes.func,
  }).isRequired,
};

export default TopVideoPageBannerComponent;
